import clsx from 'clsx';
import React from 'react';

export type MetricType = 'default' | 'success' | 'warning' | 'danger' | 'info';

export interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  type?: MetricType;
  className?: string;
}

const iconStyles: Record<MetricType, string> = {
  default: 'text-purple-600',
  success: 'text-green-500',
  warning: 'text-orange-500',
  danger: 'text-red-500',
  info: 'text-blue-500',
};

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  type = 'default',
  className,
}) => {
  return (
    <div
      className={clsx(
        'p-6 rounded-lg bg-white border border-neutral-200 transition-all duration-200 hover:shadow-sm',
        className
      )}
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <h3 className="text-sm font-normal text-neutral-600 flex-1">{title}</h3>
        {icon && (
          <div className={clsx('text-xl', iconStyles[type])}>
            {icon}
          </div>
        )}
      </div>
      {subtitle && (
        <p className="text-xs text-neutral-500 mb-2">{subtitle}</p>
      )}
      <p className="text-4xl font-semibold text-purple-600">{value}</p>
    </div>
  );
};
